
import { useEffect, useReducer } from 'react'
import { Rules } from '../models/rules'
import { rulesReducer } from '../reducers/rulesReducer'

const initialState = {
    validators: []
}

export const useRules = () => {

    const [state, dispatch] = useReducer(rulesReducer, initialState)
    const { validators } = state

    useEffect(() => {
        initLoadValidators()
    }, [])

    const initLoadValidators = async (ruleId) => {
        const data = await Rules.getValidators(ruleId)

        const action = {
            type: '[RULES] Load validators',
            payload: data
        }

        dispatch(action)
    }

    const initUpdateEstatus = async (data, validators) => {

        const newListUpdated = validators.map(it => {
            if (it.id === data.user_id) {
                return {
                    ...it,
                    enabled: data.enabled
                }
            }

            return it

        })

        const action = {
            type: '[RULES] Load validators',
            payload: newListUpdated
        }

        dispatch(action)

        const newData = {
            rule_id: data.rule_id,
            validators: newListUpdated
        }
        
        await Rules.updateStatus(newData)

    }

    return {
        validators,
        initLoadValidators,
        initUpdateEstatus
    }

}